
import { sampleSize } from "lodash"
import {AnswerType} from "@/dataType";


export function formatSample(coverArr:AnswerType[]) {
    coverArr.forEach((item) => {
        item.answers = sampleSize(item.answers, item.answers.length)
    })
    coverArr = sampleSize(coverArr, coverArr.length)
    return coverArr
}

export function getUrlParam(paraName: string): string {
    const url = document.location.toString();
    const arrObj = url.split("?");

    if (arrObj.length > 1) {
        const arrPara = arrObj[1].split("&");
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");
            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    } else {
        return "";
    }
}

const ua = navigator.userAgent.toLowerCase();

export function env() {
    const isWx = ua.search("micromessenger") !== -1;
    const isNgzb = ua.search("ngzb") !== -1;
    const isAnd = isNgzb && Reflect.has(window, "android");
    const isIos = isNgzb && Reflect.has(window, "webkit");
    return {
        isWx,
        isNgzb,
        isAnd,
        isIos,
    };
}
